// Between Us — shared reveal-on-scroll. Purposeful only: hierarchy on entry,
// nothing decorative. No-ops entirely under prefers-reduced-motion.
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var revealTargets = document.querySelectorAll('.reveal');
  if (!revealTargets.length) return;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    revealTargets.forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
  );

  revealTargets.forEach(function (el) {
    observer.observe(el);
  });
})();

// Size guide dialog open/close, delegated so it works for any number of
// product cards/sections on a page.
(function () {
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-size-guide-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-size-guide-open'));
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    var closer = event.target.closest('[data-size-guide-close]');
    if (closer) {
      var openDialog = closer.closest('dialog');
      if (openDialog) openDialog.close();
    }
  });
})();

// Signature interaction: mirror-field light. Pointer-tracked on hover/drag,
// scroll-triggered sweep otherwise. No-ops under prefers-reduced-motion,
// the light just stays at its static CSS position.
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  var field = document.querySelector('[data-mirror-field]');
  var light = document.querySelector('[data-mirror-light]');
  if (!field || !light) return;

  var sweeping = false;

  // Pixel-based transform, set once JS takes over, so every subsequent
  // update is compositor-only (no layout reflow from left/top writes).
  function setLightPosition(xPercent, yPercent) {
    var rect = field.getBoundingClientRect();
    var x = (xPercent / 100) * rect.width;
    var y = (yPercent / 100) * rect.height;
    light.classList.add('is-active');
    light.style.setProperty('--lx', x + 'px');
    light.style.setProperty('--ly', y + 'px');
  }

  function runSweep() {
    if (sweeping) return;
    sweeping = true;
    var start = null;
    var duration = 2400;

    function step(timestamp) {
      if (!start) start = timestamp;
      var elapsed = timestamp - start;
      var t = Math.min(elapsed / duration, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      setLightPosition(-10 + eased * 120, 50);
      if (t < 1) {
        requestAnimationFrame(step);
      } else {
        sweeping = false;
      }
    }
    requestAnimationFrame(step);
  }

  if ('IntersectionObserver' in window) {
    var sweepObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            runSweep();
            sweepObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    sweepObserver.observe(field);
  }

  function handlePointer(clientX, clientY) {
    var rect = field.getBoundingClientRect();
    var x = ((clientX - rect.left) / rect.width) * 100;
    var y = ((clientY - rect.top) / rect.height) * 100;
    setLightPosition(x, y);
  }

  field.addEventListener('pointermove', function (event) {
    handlePointer(event.clientX, event.clientY);
  });

  field.addEventListener(
    'touchmove',
    function (event) {
      var touch = event.touches[0];
      if (!touch) return;
      handlePointer(touch.clientX, touch.clientY);
    },
    { passive: true }
  );
})();

// Cart drawer: Ajax quantity/remove via /cart/change.js, no full reload.
// The bag link's real href (/cart) stays the working no-JS fallback; this
// only intercepts the click when JS is present and the drawer exists.
(function () {
  var drawer = document.getElementById('btwyn-cart-drawer');
  if (!drawer) return;
  var body = drawer.querySelector('[data-cart-drawer-body]');
  var errorEl = drawer.querySelector('[data-cart-error]');
  var moneyFormat = drawer.getAttribute('data-money-format') || '${{amount}}';
  var lastFocused = null;

  // Real store money format (e.g. "Rs. {{amount}}"), amount in the shop's
  // major currency unit with 2 decimals — avoids assuming Shopify.formatMoney
  // is loaded, which it isn't by default.
  function formatMoney(cents) {
    var value = cents / 100;
    var amount = value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function openDrawer() {
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('.btwyn-cart-drawer__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  }

  document.addEventListener('click', function (event) {
    var bagLink = event.target.closest('.btwyn-header__bag');
    if (bagLink) {
      event.preventDefault();
      openDrawer();
      return;
    }
    if (event.target.closest('[data-cart-drawer-close]')) {
      closeDrawer();
      return;
    }
    var qtyBtn = event.target.closest('[data-cart-qty-increase], [data-cart-qty-decrease], [data-cart-remove]');
    if (qtyBtn) {
      var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
      var itemEl = drawer.querySelector('[data-cart-line="' + line + '"]');
      var isRemove = qtyBtn.hasAttribute('data-cart-remove');
      var quantity;
      if (isRemove) {
        quantity = 0;
      } else {
        var valueEl = itemEl.querySelector('[data-cart-qty-value]');
        var current = parseInt(valueEl.textContent, 10) || 0;
        quantity = qtyBtn.hasAttribute('data-cart-qty-increase') ? current + 1 : Math.max(0, current - 1);
      }
      updateLine(line, quantity, itemEl);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  function updateLine(line, quantity, itemEl) {
    if (errorEl) { errorEl.hidden = true; }
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cartData) {
        if (quantity === 0 && itemEl) {
          itemEl.remove();
        } else if (itemEl) {
          var valueEl = itemEl.querySelector('[data-cart-qty-value]');
          if (valueEl) valueEl.textContent = quantity;
        }
        var countEls = document.querySelectorAll('[data-cart-count]');
        countEls.forEach(function (el) { el.textContent = cartData.item_count; });
        var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
        if (subtotalEl && typeof cartData.total_price === 'number') {
          subtotalEl.textContent = formatMoney(cartData.total_price);
        }
        if (cartData.item_count === 0) {
          location.reload();
        }
      })
      .catch(function () {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = 'COULD NOT UPDATE YOUR BAG. TRY AGAIN.';
        }
      });
  }
})();

// Predictive search: real /search/suggest.json, grouped by resource type,
// keyboard-navigable. Falls back to the search icon's real /search href
// with JS off.
(function () {
  var panel = document.getElementById('btwyn-predictive-search');
  if (!panel) return;
  var input = document.getElementById('btwyn-predictive-search-input');
  var results = panel.querySelector('[data-search-results]');
  var clearBtn = panel.querySelector('[data-search-clear]');
  var searchMoneyFormat = panel.getAttribute('data-money-format') || '${{amount}}';
  var debounceTimer = null;

  // /search/suggest.json returns price as an unformatted decimal string
  // ("22880.00"), not run through the shop's money format — format it the
  // same way the cart drawer does, from the shop's real format string.
  function formatSearchPrice(rawPrice) {
    if (!rawPrice) return '';
    var value = parseFloat(rawPrice);
    if (isNaN(value)) return String(rawPrice);
    var amount = value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return searchMoneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function openPanel() {
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    input.focus();
  }

  function closePanel() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-search-open]');
    if (opener) {
      event.preventDefault();
      openPanel();
      return;
    }
    if (event.target.closest('[data-search-close]')) {
      closePanel();
      return;
    }
    if (event.target.closest('[data-search-clear]')) {
      input.value = '';
      results.innerHTML = '';
      clearBtn.hidden = true;
      input.focus();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
  });

  input.addEventListener('input', function () {
    var query = input.value.trim();
    clearBtn.hidden = query.length === 0;
    if (debounceTimer) clearTimeout(debounceTimer);
    if (query.length < 2) {
      results.innerHTML = '';
      return;
    }
    debounceTimer = setTimeout(function () {
      fetchSuggestions(query);
    }, 220);
  });

  function fetchSuggestions(query) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=show';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        renderResults(data.resources && data.resources.results);
      })
      .catch(function () {
        results.innerHTML = '<p class="btwyn-predictive-search__empty font-mono">SEARCH IS UNAVAILABLE RIGHT NOW.</p>';
      });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/"/g, '&quot;');
  }

  function renderResults(res) {
    if (!res) { results.innerHTML = ''; return; }
    var html = '';
    if (res.products && res.products.length) {
      html += '<div class="btwyn-predictive-search__group"><p class="btwyn-predictive-search__group-title font-mono">PRODUCTS</p><div class="btwyn-predictive-search__grid">';
      res.products.forEach(function (p) {
        html += '<a class="btwyn-predictive-search__item" href="' + escapeAttr(p.url) + '">' +
          (p.image ? '<img src="' + escapeAttr(p.image) + '" alt="" loading="lazy">' : '') +
          '<span class="btwyn-predictive-search__item-meta font-mono"><span>' + escapeHtml(p.title) + '</span><span>' + escapeHtml(formatSearchPrice(p.price)) + '</span></span></a>';
      });
      html += '</div></div>';
    }
    var linkTypes = [
      { key: 'collections', label: 'COLLECTIONS' },
      { key: 'pages', label: 'PAGES' },
      { key: 'articles', label: 'JOURNAL' }
    ];
    linkTypes.forEach(function (t) {
      if (res[t.key] && res[t.key].length) {
        html += '<div class="btwyn-predictive-search__group"><p class="btwyn-predictive-search__group-title font-mono">' + t.label + '</p><div class="btwyn-predictive-search__link-list">';
        res[t.key].forEach(function (item) {
          html += '<a href="' + escapeAttr(item.url) + '">' + escapeHtml(item.title) + '</a>';
        });
        html += '</div></div>';
      }
    });
    results.innerHTML = html || '<p class="btwyn-predictive-search__empty font-mono">NOTHING FOUND.</p>';
  }
})();
